import {adminHttpClient} from "../commons/adminHttpClient";
import { AuditReportDto, AuditReportFilter } from "./auditableSubjectsReport";

export const generateAuditsGenderReport = (filter : AuditReportFilter) : Promise<AuditReportDto> => {
    return adminHttpClient.post(`reports/auditsGender/generate`, filter);
}

export const generateAuditsGenderReportExcel = (filter : AuditReportFilter) : Promise<string> => {
    return adminHttpClient.post(`reports/auditsGender/generateExcel`, filter);
}